import {ReactNode, useCallback, useEffect} from 'react';
import {useUrl} from '@shopify/hydrogen';
import {useGlobalContainer} from '../contexts/GlobalContainerProvider.client';

interface WidgetAreaProps {
  children: ReactNode | ReactNode[];
  title: string;
  onClick?: () => void;
}

export default function WidgetArea({
  children,
  title,
  onClick,
}: WidgetAreaProps) {
  const {setIsWidgetActive} = useGlobalContainer();
  const {href} = useUrl();

  const handleClick = useCallback(() => {
    onClick?.();
    setIsWidgetActive((value) => !value);
  }, [onClick, setIsWidgetActive]);

  // close widgets area when navigating away
  useEffect(() => {
    setIsWidgetActive(false);
  }, [href, setIsWidgetActive]);

  return (
    <aside className="widget-area">
      <div className="widgets">
        <div
          role="button"
          tabIndex={-1}
          onClick={handleClick}
          className="widgets-mobile-header"
        >
          <div className="container">
            <i className="icon-sidebar"></i>
            <span>{title}</span>
            <i className="icon-bottom-arrow-circle"></i>
          </div>
        </div>
        {children}
      </div>
    </aside>
  );
}
